var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShowerCurtains = function SvgShowerCurtains(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABELS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.21,76.19a12.72,12.72,0,0,1,9.95,12.41v4c2.89,4.9,8.73,8.27,15.48,8.27,7.51,0,13.9-4.15,16.35-10V88.6a12.73,12.73,0,0,1,12.59-12.72V67.77H154.21Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.14,76.14A12.72,12.72,0,0,1,369.26,88.6v6.45a18.39,18.39,0,0,0,13.68,5.81c7.51,0,13.9-4.15,16.35-10V88.6A12.73,12.73,0,0,1,412,75.87h1.48v-8.1H359.14Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,67.77V76A12.73,12.73,0,0,1,301.88,88.6v5a18,18,0,0,0,14.84,7.28c7.51,0,13.9-4.15,16.35-10V88.6A12.73,12.73,0,0,1,345.2,75.9V67.77Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.91,67.77v8.46A12.74,12.74,0,0,1,95.67,88.6v3.14c2.69,5.36,8.81,9.12,16,9.12,7.51,0,13.9-4.15,16.35-10V88.6a12.73,12.73,0,0,1,12.3-12.71V67.77Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.91,
    y: 57.64,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,57.64V35.33a2,2,0,0,0-2-2H18.75a2,2,0,0,0-2,2V90.08a2,2,0,0,0,2,2h11.1a2,2,0,0,0,2-2V67.77H72V57.64Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.21,
    y: 57.64,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.14,
    y: 57.64,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.52,
    y: 57.64,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.83,
    y: 57.64,
    width: 54.37,
    height: 10.13,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.79,33.33h-11.1a2,2,0,0,0-2,2V57.64H427.44V67.77H573.69V90.08a2,2,0,0,0,2,2h11.1a2,2,0,0,0,2-2V35.33A2,2,0,0,0,586.79,33.33Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,75.87a13.26,13.26,0,0,1,3,.36V46.33A4.91,4.91,0,0,0,81,41.43H76.87a4.9,4.9,0,0,0-4.9,4.9V75.88h11Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,75.89l.43,0h10.73a12.67,12.67,0,0,1,2.78.32V41.43H140.27V75.89Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.52,41.43H208.58V75.88h10.87a12.91,12.91,0,0,1,3.07.39V41.43Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.15,75.87a13.28,13.28,0,0,1,1.68.12V46.33a4.91,4.91,0,0,0-4.91-4.9h-4.13a4.9,4.9,0,0,0-4.9,4.9V76a12.82,12.82,0,0,1,1.53-.1Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.2,75.9c.2,0,.4,0,.6,0h10.73a12.56,12.56,0,0,1,2.61.27V41.43H345.2V75.9Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.44,41.43H413.5V75.87h9.25a12.6,12.6,0,0,1,4.69.91V41.43Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,89.35a13.91,13.91,0,0,0,.93,2.39V88.6a12.74,12.74,0,0,0-9.76-12.37,13.26,13.26,0,0,0-3-.36H72A12.72,12.72,0,0,0,59.48,88.6v483a12.73,12.73,0,0,0,12.73,12.74H82.94a12.73,12.73,0,0,0,12.73-12.74v-3.47a13.91,13.91,0,0,0-.93,2.39Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,89.35a13.69,13.69,0,0,0,1.4,3.24v-4a12.79,12.79,0,0,0-12.73-12.73H140.7l-.43,0A12.73,12.73,0,0,0,128,88.6v2.3c.1-.25.21-.49.3-.75V569.76c-.09-.26-.2-.5-.3-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73a12.73,12.73,0,0,0,12.73-12.74v-4.32a13.69,13.69,0,0,0-1.4,3.24Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.27,90.15c-.09.26-.2.5-.3.75-2.45,5.81-8.84,10-16.35,10-7.14,0-13.26-3.76-16-9.12a13.91,13.91,0,0,1-.93-2.39V570.56a13.91,13.91,0,0,1,.93-2.39c2.69-5.36,8.81-9.12,16-9.12,7.51,0,13.9,4.15,16.35,10,.1.25.21.49.3.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,75.87h-.14A12.73,12.73,0,0,0,196,88.6v2.3c.11-.25.21-.49.3-.75V569.76c-.09-.26-.19-.5-.3-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73a12.73,12.73,0,0,0,12.73-12.74V88.6a12.72,12.72,0,0,0-9.66-12.34,12.91,12.91,0,0,0-3.07-.39Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.29,90.15c-.09.26-.19.5-.3.75-2.45,5.81-8.84,10-16.35,10-6.75,0-12.59-3.37-15.48-8.27a13.69,13.69,0,0,1-1.4-3.24V570.56a13.69,13.69,0,0,1,1.4-3.24c2.89-4.9,8.73-8.27,15.48-8.27,7.51,0,13.9,4.15,16.35,10,.11.25.21.49.3.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.84,89.35a14.14,14.14,0,0,0,2,4.23v-5A12.73,12.73,0,0,0,290.83,76a13.28,13.28,0,0,0-1.68-.12H278.42A12.8,12.8,0,0,0,265.69,88.6v2.3c.11-.25.22-.49.31-.75V569.76c-.09-.26-.2-.5-.31-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73a12.73,12.73,0,0,0,12.73-12.74v-5.31a13.91,13.91,0,0,0-2,4.23Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,90.15c-.09.26-.2.5-.31.75-2.45,5.81-8.84,10-16.35,10-8.16,0-15-4.9-16.88-11.51V570.56c1.89-6.61,8.72-11.51,16.88-11.51,7.51,0,13.9,4.15,16.35,10,.11.25.22.49.31.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.05,89.35a14.63,14.63,0,0,0,3.21,5.7V88.6a12.72,12.72,0,0,0-10.12-12.46,12.56,12.56,0,0,0-2.61-.27H345.8c-.2,0-.4,0-.6,0a12.73,12.73,0,0,0-12.13,12.7v2.3c.1-.25.21-.49.3-.75V569.76c-.09-.26-.2-.5-.3-.75v2.63a12.73,12.73,0,0,0,12.73,12.74h10.73a12.73,12.73,0,0,0,12.73-12.74v-6.78a14.63,14.63,0,0,0-3.21,5.7Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.37,90.15c-.09.26-.2.5-.3.75-2.45,5.81-8.84,10-16.35,10a18,18,0,0,1-14.84-7.28,14.14,14.14,0,0,1-2-4.23V570.56a13.91,13.91,0,0,1,2-4.23,18,18,0,0,1,14.84-7.28c7.51,0,13.9,4.15,16.35,10,.1.25.21.49.3.75Z",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,75.87H412A12.73,12.73,0,0,0,399.29,88.6v2.3c.1-.25.21-.49.3-.75V569.76c-.09-.26-.2-.5-.3-.75v2.63A12.73,12.73,0,0,0,412,584.38h10.73a12.73,12.73,0,0,0,12.73-12.74V88.6a12.78,12.78,0,0,0-12.73-12.73Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.59,90.15c-.09.26-.2.5-.3.75-2.45,5.81-8.84,10-16.35,10a18.39,18.39,0,0,1-13.68-5.81,14.63,14.63,0,0,1-3.21-5.7V570.56a14.63,14.63,0,0,1,3.21-5.7,18.39,18.39,0,0,1,13.68-5.81c7.51,0,13.9,4.15,16.35,10,.1.25.21.49.3.75Z",
    fill: "#16a99e"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShowerCurtains, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shower_curtains.606ed6d8.svg";
export { ForwardRef as ReactComponent };